export default function calPressButton(type){
    let divs = document.querySelectorAll('.fc-'+type+'-button');
    for (let i = 0; i < divs.length; ++i) {
        divs[i].click();
    }
}
